import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { IAlertaBotonBLE, IFilter, IPopulate, IQueryParam } from 'modelos/src';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../../auxiliares/tabla/filtro/filtro.component';
import { IColumnas } from '../../../../../auxiliares/tabla/tabla.component';
import { AuxiliaresModule } from '../../../../../auxiliares/auxiliares.module';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';

@Component({
  imports: [AuxiliaresModule],
  selector: 'app-alertas-boton-ble',
  templateUrl: './alertas-botones-ble.component.html',
  styleUrl: './alertas-botones-ble.component.scss',
})
export class AlertasBotonesBLEComponent implements OnInit, OnDestroy {
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  dialog = inject(MatDialog);

  public loading = false;
  //// Tabla nueva
  @Input() public mac: string = null;

  public name = 'AlertasBotonesBLEComponent';
  public alertasBotonesBLE: IAlertaBotonBLE[] = [];
  public alertasBotonesBLE$?: Subscription;
  public totalCount = 0;
  public columnas?: IColumnas<IAlertaBotonBLE>[];

  //FILTROS

  // La alerta sólo guarda la MAC como texto propio; el resto son referencias.
  public search: IRegExpSearch = {
    fields: ['mac'],
  };

  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
    // filtroSelector: ['moduloBotonBLE'],
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };

  private fecha: IFiltroTabla = {
    filter: {
      field: 'fechaCreacion',
    },
    label: 'Fecha',
    tipo: 'dateRange',
  };
  public filtros: IFiltroTabla[] = [this.fecha, this.cliente, this.ancestro];

  // POPULATE

  public populate: IPopulate[] = [
    {
      path: 'dispositivoLorawan',
    },
    {
      path: 'luminaria',
    },
  ];

  // QUERY: la tabla la enlaza con [(query)] y le escribe filtro, búsqueda,
  // página, tamaño y orden.
  public query: IQueryParam = {
    populate: JSON.stringify(this.populate),
    sort: '-fechaCreacion',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };

  //LISTADO
  public async listar(): Promise<void> {
    // La MAC del botón se suma al filtro que arma la tabla, sin pisarlo.
    const filter: IFilter<IAlertaBotonBLE> = this.query.filter
      ? JSON.parse(this.query.filter)
      : {};
    if (this.mac) filter.mac = this.mac;
    const query: IQueryParam = {
      ...this.query,
      filter: JSON.stringify(filter),
    };
    this.loading = true;
    this.alertasBotonesBLE$?.unsubscribe();
    this.alertasBotonesBLE$ = this.lista2
      .alertaBles(query, 30)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.alertasBotonesBLE = data.datos;
        this.loading = false;
      });
  }

  // Tabla

  private setColumnas() {
    const columnas: IColumnas<IAlertaBotonBLE>[] = [
      // Fecha Creación
      {
        header: {
          label: 'Fecha de creación',
          sortable: true,
          sort: 'fechaCreacion',
        },
        row: {
          fecha: (dato) => dato.fechaCreacion,
          hace: true,
        },
      },

      // Dispositivo Lorawan
      {
        header: {
          label: 'Dispositivo LoRaWAN',
        },
        row: {
          parse(dato) {
            return dato?.dispositivoLorawan?.name;
          },
          noData: 'Sin dispositivo',
        },
      },

      // Luminaria
      {
        header: {
          label: 'Luminaria',
        },
        row: {
          parse(dato) {
            return dato?.luminaria?.identificacion;
          },
          noData: 'Sin luminaria',
        },
      },
    ];

    // Acciones
    // columnas.push({
    //   header: {
    //     label: 'Acciones',
    //   },
    //   row: {
    //     acciones: [
    //       {
    //         tipo: 'material',
    //         color: 'primary',
    //         icon: 'visibility',
    //         tooltip: 'Detalles',
    //         click: (dato) => this.detalles(dato),
    //       },
    //     ],
    //   },
    // });

    this.columnas = columnas;
  }

  // Hooks

  async ngOnInit() {
    this.setColumnas();
    Promise.all([this.listar()]);
  }

  async ngOnDestroy() {
    this.alertasBotonesBLE$?.unsubscribe();
  }
}
